// ProfileInfoUserHashtags.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { textColor } from '../style/variables';
import media from '../style/media';
import { TranslationNamespace } from '../resource/translationNamespace';
import trackMixpanel, {
  ButtonId,
  EventTypes,
  getViewId,
} from '../resource/mixpanel.js';

export const ProfileInfoUserHashtags = ({ hashtags, hashtagFeedUser }) => {
  const { t } = useTranslation();
  return (
    <StyledProfileInfoUserHashtags>
      {hashtags.map((hashtag, index) => {
        const feedName = hashtagFeedUser.replace('{HASHTAG}', hashtag);
        return (
          <UserHashtagLink
            key={index}
            to={`/user-feed-grid/${feedName}`}
            onClick={() => {
              trackMixpanel({
                type: EventTypes.USER_CLICKED,
                payload: {
                  viewId: getViewId({
                    pathname: window.location.pathname,
                  }),
                  buttonId: ButtonId.Hashtag.ButtonUserHashtag,
                  extraProps: {
                    hashtag,
                  },
                },
              });
            }}
          >
            {t(`user_hashtag_${hashtag}`, { ns: TranslationNamespace.PROFILE })}
          </UserHashtagLink>
        );
      })}
    </StyledProfileInfoUserHashtags>
  );
};

ProfileInfoUserHashtags.propTypes = {
  hashtagFeedUser: PropTypes.string,
  hashtags: PropTypes.array,
};

ProfileInfoUserHashtags.defaultProps = {
  hashtagFeedUser: '',
  hashtags: [],
};

const StyledProfileInfoUserHashtags = styled.div``;

const UserHashtagLink = styled(Link)`
  margin-right: 8px;
  margin-bottom: 4px;
  display: inline-block;
  border-radius: 40px;
  padding: 2px 8px;
  background-color: rgba(221, 221, 221, 0.2);
  color: ${textColor.primary};
  line-height: 150%; /* 24px */
  letter-spacing: 0.024px;
  font-size: 16px;
  ${media.tablet`
  font-size: 12px;
`};
`;

export default ProfileInfoUserHashtags;
